import { Component, type ErrorInfo, type ReactNode } from "react";

type State = { error: Error | null };

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State { return { error }; }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) console.error("MEDTL Regulatory Auditor UI boundary", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="content"><section className="error-state" role="alert"><strong>MEDTL Regulatory Auditor could not display this screen</strong><p>The received data or screen state was invalid. No controlled record was changed.</p><button className="button primary" type="button" onClick={() => window.location.reload()}>Reload screen</button></section></main>;
  }
}
